import { render, staticRenderFns } from "./ContextCard.vue?vue&type=template&id=3d8e8f16&scoped=true"
import script from "./ContextCard.vue?vue&type=script&lang=js"
export * from "./ContextCard.vue?vue&type=script&lang=js"
import style0 from "./ContextCard.vue?vue&type=style&index=0&id=3d8e8f16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8e8f16",
  null
  
)

export default component.exports